import { render, staticRenderFns } from "./purchaseMember.vue?vue&type=template&id=407ff36b&scoped=true"
import script from "./purchaseMember.vue?vue&type=script&lang=js"
export * from "./purchaseMember.vue?vue&type=script&lang=js"
import style0 from "./purchaseMember.vue?vue&type=style&index=0&id=407ff36b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ff36b",
  null
  
)

export default component.exports